import { PropAppParamV3Schema } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { FormLabel } from "ui/form-label";

import { PRIORITY } from "./utils";

function FieldLabel({ priority, schema }) {
  const { display_name: displayName, required: isRequired } = schema;

  const required = priority > PRIORITY.NETWORK && isRequired;
  return (
    <FormLabel as="label" required={required}>
      {displayName}
    </FormLabel>
  );
}

FieldLabel.propTypes = {
  priority: PropTypes.oneOf([PRIORITY.DEVICE, PRIORITY.NETWORK]).isRequired,
  schema: PropAppParamV3Schema.isRequired,
};

export { FieldLabel };
